import { ITreeNode } from "./tree/interfaces"

export const stringify = (object: any, keys?: string[]) =>
  JSON.stringify(object, keys)
export const stringifyTree = (
  tree: ITreeNode[] | ITreeNode // JSON.stringify(tree)
) =>
  JSON.stringify(tree, [
    "id",
    "title",
    "children",
    "isMapped",
    "nbRef",
    "isLeaf",
    "isTechMapped",
    "isInactive",
    "isMappedToInactive",
    "hasMargin",
    "value",
    "className",
    "hasPausedMapping",
    "evolution",
    "marginInfo",
  ])
